import { render } from "./ContentblockLocation.vue?vue&type=template&id=378db824&scoped=true&ts=true"
import script from "./ContentblockLocation.ts?vue&type=script&lang=ts"
export * from "./ContentblockLocation.ts?vue&type=script&lang=ts"

import "./ContentblockLocation.scss?vue&type=style&index=0&id=378db824&lang=scss&scoped=true"

import exportComponent from "/Users/koenverbruggen/Sites/02-SITES/nederlandsmijnmuseum.local/wp-content/themes/nmm/js/vue/nmm/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-378db824"]])

export default __exports__